import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const HomeButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/");
  };

  return (
    <Button
      data-testid="homeButton"
      variant="contained"
      onClick={handleClick}
      sx={{
        marginTop: "20px",
        paddingX: "30px",
        paddingY: "10px",
        fontSize: "16px",
      }}
    >
      Return to Home
    </Button>
  );
};

export default HomeButton;
